import React, { ReactNode } from "react";

const Header = ({ label, leftComp }: { label: string; leftComp?: ReactNode }) => {
  return (
    <div className="sticky top-0 z-40 w-full h-14 bg-white border-b border-gray-200 px-4 flex items-center justify-between shadow-sm">
      <div className="flex items-center gap-4">
        <h2 className="text-lg font-semibold text-gray-800">
          {label}
        </h2>
      </div>
      
      <div className="flex items-center gap-3">
        {leftComp}
      </div>
    </div>
  );
};

export default Header;
